module.exports = __webpack_public_path__ + "img/icon_005.299b557.png";